<script>
import metaInfo from '@/modules/mixins/metaInfo'
import Vue from 'vue'
import CanteenPickup from '@/components/organism/canteen/CanteenPickup'
import canteenAddresses from '@/modules/mixins/canteenAddresses'
import CanteenBanner from '@/components/organism/canteen/CanteenBanner'
import store from '@/modules/store'

export default {
    name: 'Pickup',
    components: { CanteenBanner, CanteenPickup },
    mixins: [canteenAddresses, metaInfo],
    data() {
        return {
            ready: false,
        }
    },
    computed: {
        pageTitle() {
            return this.$t('canteen.company_pickup')
        },
    },
    async beforeRouteEnter(to, from, next) {
        const getMe = from.name ? Vue.prototype.$user.getMe() : undefined
        const residentialCanteens = store.dispatch('canteen/getResidentialList', true)
        await Promise.all([getMe, residentialCanteens])
        next()
    },

    async mounted() {
        const addresses = [...this.residentialCanteenAddresses, ...this.cloudCanteenAddresses]
        if (addresses.length === 1) {
            this.gotoFistAddress()
        }
        this.ready = true
    },

    methods: {
        gotoFistAddress() {
            let id = null
            let type = null
            if (this.cloudCanteenAddresses.length) {
                id = this.cloudCanteenAddresses[0].id
                type = this.cloud
            }
            if (this.residentialCanteenAddresses.length) {
                id = this.residentialCanteenAddresses[0].id
                type = this.residential
            }

            this.$router.replace(`/canteen/${type}/${id}`)
        },
    },
}
</script>

<template lang="pug">
.canteen-pickups.mt-5.mt-md-0(v-if="ready")
    canteen-banner.mb-9(v-if="$user.onlyCloudCanteen")
    .mb-9(v-if="hasCC")
        h3 {{ $t('canteen.company_pickup') }}
        canteen-pickup(
            v-for="(address, index) in cloudCanteenAddresses"
            :type="cloud"
            :model="address"
            :class="{'mt-9': index}"
            :key="`cloudCanteenAddress-${address.id}`")
    template(v-if="hasRC")
        h3 {{ $t('canteen.residential_pickup') }}
        canteen-pickup(
            v-for="(address, index) in residentialCanteenAddresses"
            :type="residential"
            :model="address"
            :class="{'mt-9': index}"
            :key="`residentialCanteenAddress-${address.id}`")
    h2.my-4.text-center.text-primary(v-if="!hasCC && !hasRC") {{$t('canteen.empty')}}
</template>
